import fetch from '@/utils/fetch';

interface IUpdateStatusParams {
  id?: number; //id
  status?: number; //是否生效
  isSyncSku?: number; //是否同步菜品
  isSyncShop?: number; //是否同步门店
  isSyncOrder?: number; //是否同步订单
}
export const tpShopUpdateStatus = (params: IUpdateStatusParams) =>
  fetch<boolean>('/saasmerchant/web/bms/tpShop/tpShopUpdateStatus', {
    params,
    type: 'POST',
    useJson: true,
  });

/**外部对接列表的返回值，之前接口都写在了store里，还是是js，所以只能在这里加上类型定义 */
export interface ITpShopListRes {
  accessSecretEncrypt: string;
  creator: string;
  /**id用于失效生效同步设置操作 */
  id: number;
  shopId: number;
  shopName: string;
  status: number;
  tpShopId: string;
  tpShopType: number;
  /** 是否同步门店*/
  isSyncShop: number;
  /**是否同步菜品 */
  isSyncSku: number;
  /**是否同步订单 */
  isSyncOrder: number;
  createTime: number;
  updateTime: number;
  subShopId: number;
}
export interface ITpShopListParams {
  sub_shop_id?: number; //子们店id
  shop_name?: string; //三方类型
  status?: number; //是否有效
  type?: number; //外部类型
  page: number; //默认1
  pageSize: number; //默认10
}
/**获取外部对接列表数据 */
export const getTpShopList = (params: ITpShopListParams) =>
  fetch<{ total: number; list: ITpShopListRes[] }>('/saasmerchant/web/bms/tpShop/tpShopList', {
    params,
    type: 'POST',
    useJson: true,
  });
